import { ValidationError } from "../../errors/validation-error";
import { RealtimeRequest } from "./realtime-request";
import { RealtimeValidator } from "./validators/realtime-validator";

/**
 * A request for sending real-time notifications to all users.
 */
export class RealtimeRequestBroadcast extends RealtimeRequest {
    validate(): void {
        const failures = new RealtimeValidator().validate(this);
        if (failures.length > 0) {
            throw new ValidationError(`RealtimeRequestBroadcast is invalid`, ...failures);
        }
    }
}
